import React, { useState } from 'react';
import { Box, IconButton, Paper, Typography, Button, Dialog, DialogContent, DialogActions, Stack, TextField, Grid, Divider, Alert } from '@mui/material';
import { AddCircleOutline, Save, Close, CloudUpload } from '@mui/icons-material';
import InputForm from "../../../InputT";
import SearInputG from "../../../SearchInput";
import SearchModal from '../../../SearchModal';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import SweetAlert from "sweetalert2";
import { Select, Input, Upload, Form } from 'antd';
import AntTable from '../../../TableResizable';
import { SearchOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import CheckBox from "../../../CheckBox";

const { Option } = Select;
const { TextArea } = Input;

const searchCat: ParamsPicklist = { CodeAgence: '', Table: "CategorieActif", Colonne1: "CodeCategorie", Colonne2: "Libelle", Colagence: '101', Choix: 22 };
const searchFam: ParamsPicklist = { CodeAgence: '', Table: "FamilleActif", Colonne1: "CodeFamille", Colonne2: "Libelle", Colagence: '101', Choix: 22 };


interface ParentColumn {
    key: string;
    label: string;
    width?: number;
    align?: 'left' | 'center' | 'right';
    render: (row: any) => React.ReactNode;
}

interface Tab1Props {
    form?: any;
    selectedActif: any;
    listeAttente: any[];
    columns: ParentColumn[];
    listFinancements?: any[];
    selectedRowKeys: React.Key[];
    //required?: boolean;
    //disabled?: boolean;
    onSelectChange: (keys: any) => void;
    showRejet: boolean;
}

const Tab1 = (props: Tab1Props) => {
    const disabled = true;
    const [search, setSearch] = useState('');
    //const required = true;
    
    const antdColumns: ColumnsType<any> = props.columns.map((col: ParentColumn) => ({
        title: col.label, dataIndex: col.key, key: col.key, width: col.width, align: col.align || 'left',
        render: (_v: any, record: any) => col.render(record)
    }));
    const filteredListeAttente = props.listeAttente.filter((row: any) =>
        Object.values(row).some(value => String(value ?? '').toLowerCase().includes(search.toLowerCase()))
    );

    return (
        <div className='tabItemAuto'>
            <Box className='border' sx={{ width: "85%", position: "absolute" }}>
                <legend> CONTRÔLE ET VALIDATION DES ACTIFS </legend>

                <Box sx={{ p: 2, mt: -2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={6} sx={{ pr: 2 }}>
                            <legend> Contexte de la catégorie </legend>
                            {/* Toujours en lecture seule : DemandeActif ne modifie jamais la catégorie */}
                            <SearchModal width={5} notRequired form={props.form} Titre={'Recherche Catégorie'} label={'Code Catégorie'} name={'CODECATEGORIE'} Parametre={searchCat} disabled={disabled} />
                            <SearInputG width={5} form={props.form} Titre={'Recherche Famille'} label={'Famille'} name={'FAMILLE'} Parametre={searchFam} dissabledCode={disabled} />
                            <InputForm width={6} label="Règles d'usage" type="TextArea" name="REGLESUSAGE" disabled={true} row={1} />

                            <Form.Item label="Financements" name="FINANCEMENT_ELIGIBLES" labelCol={{ span: 6 }} labelAlign="left">
                                <Select mode="multiple" placeholder="Types autorisés" style={{ width: '100%' }} disabled={disabled}>
                                    {props.listFinancements?.map((f: any) => <Option key={f.CODE} value={f.CODE}>{f.LIBELLE}</Option>)}
                                </Select>
                            </Form.Item>

                            <Box sx={{ ml: `${(7 / 24) * 100}%`, mt: 2, display: 'flex', alignItems: 'center', gap: 2, '& .ant-form-item': { marginBottom: 0 } }}>
                                <CheckBox notRequired form={props.form} label="Actif" name="ESTACTIF" disabled={disabled} />
                            </Box>
                            
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} className='border-left' sx={{ pl: 2 }}>
                            <legend> Détails de l'actif </legend>
                            <InputForm
                                width={6}   
                                label="N° Série / Unique" 
                                type="texte"
                                name="IDENTIFIANTUNIQUE"  
                                disabled={disabled} 
                                />
                            <InputForm
                                width={6}   
                                label="Localisation" 
                                type="texte"
                                name="LOCALISATIONCOURANTE"  
                                disabled={disabled} 
                                />
                            <InputForm 
                                width={7} 
                                notRequired
                                label="Saisi par" 
                                name="UPDATEDBY" 
                                type='text' 
                                disabled={disabled} 
                                />

                                <InputForm 
                                width={7} 
                                notRequired
                                label="Date de saisi" 
                                name="DATEMODIFICATION" 
                                type='text' 
                                disabled={disabled}
                                />
                                {props.showRejet && (
                            <InputForm 
                                width={7}
                                label="Motif de rejet" 
                                name="COMMENTAIRE_VALIDATEUR" 
                                type='TextArea'  
                                disabled={false} 
                                row={2}
                                />
                                )}
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ p: 2, mt: -2 }}>
                    <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2} gap={2}>
                            <Box>
                                <Typography variant="h6" fontWeight="bold" color="#04446e">Actifs en attente de validation</Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {props.listeAttente.length} actif(s) nécessitant une décision
                                </Typography>
                                {/* <Box sx={{ mt: 1 }}>
                                    <Typography variant="body2" display="block" color="textSecondary">{countPending} actif(s) en attente</Typography>
                                    <Typography variant="body2" display="block" color="textSecondary">{countRejected} actif(s) rejeté(s)</Typography>
                                </Box> */}
                                {/* <Button
                                    type="primary"
                                    icon={<Refresh />}
                                    loading={loading}
                                    onClick={onRefresh}
                                    style={{ backgroundColor: '#2A6596' }}
                                >
                                    Actualiser l'inventaire
                                </Button> */}
                            </Box>
                            <Input size="small" allowClear prefix={<SearchOutlined />} placeholder="Rechercher..." value={search} onChange={event => setSearch(event.target.value)} style={{ width: 220 }} />
                        </Box>

                        <Box sx={{ maxHeight: 'calc(100vh - 380px)', 
                            minHeight: '250px', 
                            overflowX: 'auto',
                            width: '100%',
                            '& .ant-table-content, & .ant-table-body': {
                            '&::-webkit-scrollbar': { height: '5px', width: '5px' }, // Observation : Scrollbar fine
                            '&::-webkit-scrollbar-track': { backgroundColor: '#f1f1f1' },
                            '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: '10px' },
                            '&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#2A6596' },
                        }}}>
                            <AntTable
                                //dataSource={dataAffichees}
                                dataSource={filteredListeAttente}
                                columns={antdColumns}
                                rowSelection={{ 
        type: 'radio', 
        selectedRowKeys: props.selectedRowKeys, 
        onChange: props.onSelectChange, 
    }}
                                //rowKey={(record: any) => record._key}
                            rowKey={(record: any, index?: number) => index ?? 0}                                size="small"
                                pagination={ false }
                                sticky={true}
                                scroll={{ x: 'max-content' }}
                            />
                        </Box>
                    </Paper>
                </Box>
            </Box>
        </div>
    );
};

export default Tab1;